import React from "react";

import DataTable from 'react-data-table-component';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from "react-bootstrap/ListGroup";

import { faUmbrella, faEllipsisVertical, faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class RiskHistory extends React.Component {

	state = {
		isLoading: false,
		historyList: [],
	};


	componentDidMount() {
		this.setState({ risk: this.props.risk });
		if (this.props.risk.riskID !== 0) {
			this.fetchHistoryList(this.props.risk.riskID);
		}
	}


	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			if (this.props.risk !== null && this.props.risk !== this.state.risk) {
				this.setState({ risk: this.props.risk });
				if (this.props.risk.riskID !== 0) {
					this.fetchHistoryList(this.props.risk.riskID);
				}
			}
		}
	}

	fetchHistoryList(riskID) {
		this.setState({ isLoading: true });
		fetch('api/Risk/GetRiskHistory/' + riskID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ historyList: data });
				this.setState({ isLoading: false });
			})
			.catch(error => {
				this.setState({ isLoading: false });
			})
	}

	customLoader() {
		return (
			<div style={{ padding: '24px' }}>
				<Spinner animation="border" />
				<div>Loading...</div>
			</div>
		);
	}

	menuPopup(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						<ListGroup.Item onClick={() => { document.body.click(); }}>
							<FontAwesomeIcon icon={faEye} size="sm" /> View
						</ListGroup.Item>
						
					</ListGroup>
				</Popover.Body>
			</Popover>
		);
	}

	colorIcon(row) {
		if (row.actionType === 1 || row.actionType === 4 || row.actionType === 7) {
			return (<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: '#62D96B', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />);
		} else if (row.actionType === 2 || row.actionType === 5 || row.actionType === 8) {
			return (<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: '#DB3737', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />);
		} else {
			return (<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: 'gray', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />);
		}		
	}

	menuyButton(row) {
		/*if (row.actionType !== 1 && row.actionType !== 4 && row.actionType !== 7 && row.actionType !== 2 && row.actionType !== 5 && row.actionType !== 8) {
			return (
				<OverlayTrigger trigger="click" placement="left" rootClose overlay={this.menuPopup(row)}>
					<Button variant="light" className="btn-circle"><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>
			);
		}*/
	}

	render() {
		
		const filteredData = this.state.historyList;

		const customStyles = {
			headRow: {
				style: {
					border: 'none',
				},
			},
			headCells: {
				style: {
					color: '#202124',
					fontSize: '14px',
				},
			},
			rows: {
				highlightOnHoverStyle: {
					backgroundColor: 'AliceBlue',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
			},
		};

		//row.actionType === 1 || row.actionType === 4 || row.actionType === 7 ?
		//	<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: '#62D96B', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} /> :
		//	row.actionType === 2 || row.actionType === 5 || row.actionType === 8 ?
		//		<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: '#DB3737', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} /> :
		//		<FontAwesomeIcon icon={faClockRotateLeft} style={{ backgroundColor: 'gray', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />

		const historyColumns = [
			{
				cell: (row) =>  this.colorIcon(row),
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Action',
				selector: row => row.action,
				sortable: true,
				grow: 2,
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Date',
				selector: row => row.date.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Performed by',
				selector: row => row.responsible,
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},			
			{
				cell: row => this.menuyButton(row),
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];


		return (
			<Card className="workspace-card">
				<Card.Header>
					<div style={{ float: 'left' }}>
						<b>Risk history</b>
					</div>
					
				</Card.Header>
				<Card.Body>
					<DataTable
						responsive
						className="data-table"
						columns={historyColumns}
						data={filteredData}
						customStyles={customStyles}
						progressPending={this.state.isLoading}
						progressComponent={this.customLoader()}
						highlightOnHover
						pointerOnHover
						noHeader={true}
						onRowClicked={(row, event) => {  }}
					/>
				</Card.Body>
			</Card >
		);
	}
}
export default RiskHistory;